import * as React from 'react';
import { ListPageLayoutControls } from './list-page-controls';
import { ListPageLayoutExtras } from './list-page-extras';
import { ListPageLayoutFilterDialog } from './list-page-filter-dialog';
import { ListPageLayoutFilterTrigger } from './list-page-filter-trigger';
import { ListPageLayoutHeader } from './list-page-header';
import type { IListPageLayoutProps } from './list-page-layout.types';
import { ListPageLayoutList } from './list-page-list';
import { ListPageLayoutLoadMoreSentinel } from './list-page-load-more-sentinel';
import { ListPageLayoutSearch } from './list-page-search';
import { cn } from '@utils';

const ListPageLayoutRoot = React.forwardRef<HTMLDivElement, IListPageLayoutProps>(
	({ className, children, ...props }, ref) => (
		<div
			ref={ref}
			className={cn('flex flex-col gap-5 w-full', className)}
			data-testid="list-page-layout"
			{...props}
		>
			{children}
		</div>
	)
);
ListPageLayoutRoot.displayName = 'ListPageLayout';

type ListPageLayoutCompound = typeof ListPageLayoutRoot & {
	Header: typeof ListPageLayoutHeader;
	Controls: typeof ListPageLayoutControls;
	Search: typeof ListPageLayoutSearch;
	FilterTrigger: typeof ListPageLayoutFilterTrigger;
	FilterDialog: typeof ListPageLayoutFilterDialog;
	Extras: typeof ListPageLayoutExtras;
	List: typeof ListPageLayoutList;
	LoadMoreSentinel: typeof ListPageLayoutLoadMoreSentinel;
};

export const ListPageLayout = ListPageLayoutRoot as ListPageLayoutCompound;
ListPageLayout.Header = ListPageLayoutHeader;
ListPageLayout.Controls = ListPageLayoutControls;
ListPageLayout.Search = ListPageLayoutSearch;
ListPageLayout.FilterTrigger = ListPageLayoutFilterTrigger;
ListPageLayout.FilterDialog = ListPageLayoutFilterDialog;
ListPageLayout.Extras = ListPageLayoutExtras;
ListPageLayout.List = ListPageLayoutList;
ListPageLayout.LoadMoreSentinel = ListPageLayoutLoadMoreSentinel;
